import { Box, Chip, Typography, Grid, Button, Card, CardContent, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../../../services/api';

export default function DetalheVenda() {
    const { id } = useParams();
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    const [order, setOrder] = useState(null);
    const [appId, setAppId] = useState();

    const pegar_app_padrao = async () => {
        try {
            const response = await api.get('v1/apps/default/');
            const data = response.data;
            // console.log(`pegar_app_padrao - achou`);

            if (!data?.app?.id) {
                console.warn('App ID não veio da API');
                return;
            }

            setAppId(data.app.id);
        } catch (error) {
            console.error('Erro ao buscar app padrão:', error);
        }
    };

    useEffect(() => {
        pegar_app_padrao();
    }, []);

    const fetchOrder = async () => {
        // if (!appId) return;
        const res = await api.get(`v1/apps/${appId}/orders/${id}/`);
        setOrder(res.data.order);
    };

    useEffect(() => {
        if (!appId) return;
        fetchOrder();
    }, [appId]);

    const formatDateBR = (date) => {
        if (!date) return '';
        return new Date(date).toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const formatCurrencyBR = (value) => {
        if (value === null || value === undefined || value === '') return '';

        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(Number(value));
    };

    const handleExportPDF = async () => {
        try {
            const response = await api.get(`v1/apps/${appId}/orders/${id}/gerar_relatorio/`, {
                responseType: 'blob'
            });

            // cria URL temporária do arquivo
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // cria link invisível
            const link = document.createElement('a');
            link.href = url;

            // nome do arquivo
            link.setAttribute('download', `pedido_${id}.pdf`);

            document.body.appendChild(link);
            link.click();

            // cleanup
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Erro ao baixar PDF:', error);
        }
    };

    if (!order) return <Typography>Carregando...</Typography>;

    return (
        <Box p={3}>
            <Typography variant="h2" mb={3}>
                Detalhes da Venda
            </Typography>

            {/* HEADER */}
            <Card sx={{ mb: 3 }}>
                <CardContent>
                    <Grid container spacing={4}>
                        <Grid item xs={8}>
                            <Typography mt={1} fontWeight={900}>
                                Nome: {order.user_detail?.first_name || 'Cliente sem nome'} {order.user_detail?.last_name}
                            </Typography>

                            <Typography mt={1} fontWeight={900}>
                                Telefone: {order.user_detail?.phone || 'Cliente sem telefone'}
                            </Typography>

                            <Typography mt={1} fontWeight={900}>
                                Email: {order.user_detail?.email || 'Cliente sem e-mail'}
                            </Typography>

                            <Typography mt={1} fontWeight={900}>
                                Data venda: {formatDateBR(order.created_at)}
                            </Typography>

                            {order.status === 'draft' && (
                                <Typography mt={1} fontWeight={600}>
                                    Status: Rascunho
                                </Typography>
                            )}
                            {order.status === 'pending' && (
                                <Typography mt={1} fontWeight={600}>
                                    Status: Pendente
                                </Typography>
                            )}
                            {order.status === 'approved' && (
                                <Typography mt={1} fontWeight={600}>
                                    Status: Aprovado
                                </Typography>
                            )}
                            {order.status === 'paid' && (
                                <Typography mt={1} fontWeight={600}>
                                    Status: Pago
                                </Typography>
                            )}
                            {order.status === 'canceled' && (
                                <Typography mt={1} fontWeight={600}>
                                    Status: Cancelado
                                </Typography>
                            )}
                            <Typography mt={1} fontWeight={900}>
                                Descrição: {order.notes || 'Sem descrição'}
                            </Typography>
                        </Grid>

                        <Grid item xs={4} textAlign="right">
                            <Button variant="contained" onClick={handleExportPDF}>
                                Exportar (PDF)
                            </Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            {/* PRODUTOS */}
            <Card>
                <CardContent>
                    <Typography variant="h3" mb={2}>
                        Produtos
                    </Typography>

                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 2fr 1fr 1fr 1fr 1fr',
                            fontWeight: 600,
                            mb: 2
                        }}
                    >
                        <span>Marca</span>
                        <span>Nome</span>
                        <span>Modelo</span>
                        <span>Valor unitário</span>
                        <span>Quantidade</span>
                        <span>Valor total itens</span>
                    </Box>

                    {order.items_detail.map((item) => (
                        <Box
                            key={item.id}
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: '0.9fr 2.2fr 1fr 1fr 1fr 1fr',
                                p: 2,
                                mb: 1,
                                borderRadius: 2,
                                background: isDark ? '#2d323d' : '#f9f9f9'
                            }}
                        >
                            <Typography fontWeight={600}>{item.product_marca}</Typography>
                            <Box>
                                <Typography fontWeight={600}>{item.product_name}</Typography>

                                <Typography variant="caption" color="text.secondary">
                                    {item.variacao_nome}
                                </Typography>
                            </Box>
                            <Typography fontWeight={600}>{item.product_modelo}</Typography>

                            <Typography>{formatCurrencyBR(item.unit_price)}</Typography>
                            <Typography>{item.quantity}</Typography>
                            <Typography fontWeight={600}>{formatCurrencyBR(item.total_price)}</Typography>
                        </Box>
                    ))}

                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 2fr 1fr 1fr 1fr 1fr',
                            fontWeight: 600,
                            mb: 2,
                            mt: 2
                        }}
                    >
                        <span> </span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span>
                            Total <Typography>{formatCurrencyBR(order.total_value)}</Typography>
                        </span>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
}
